// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2YnId","box":"WorkspacesBox_box__wWJLr","node":"WorkspacesBox_node__1axhj"};